import React, {} from 'react';
import { connect } from "react-redux";
import { SIDEBAR_NAVIGATION_BUTTONS_LEVEL3 } from "../../../../../constants";
import { setSQFTActiveButton, setSQFTMenuOpened } from "../../../../../../../actions/sqftMenuFunctions";
import LookFilters from "../../../../../../look/lookNavigation/lookFilters/lookFilters";

const SqftNavFiltersMenu = (props) => {
  const { activeLevel3Button } = props;
  const expanded = activeLevel3Button === SIDEBAR_NAVIGATION_BUTTONS_LEVEL3.filters

  return (
    <div className={"content side-level3" + (expanded ? " expanded" : "")}>
      <div className="side-level3__inner height-100">
        <LookFilters isRelatedItemsFilters={ false } shouldCloseLevel3Sidebar={ true }/>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const { activeLevel3Button } = store.sqftMenuState;
  return {
    activeLevel3Button
  };
};

const mapDispatchToProps = {
  setSQFTMenuOpened,
  setSQFTActiveButton
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftNavFiltersMenu);
